import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { Link } from '@calendly/ui/components/link';
import { Loader } from '@calendly/ui/components/loader';
import { TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { USER_PROVISIONING_STEPS } from './constants';
import { DeleteScimConfigurationButton } from './delete_scim_configuration_button';
import { Groups } from './group_mappings_step';
import { ScimConfiguration } from './scim_step';
import { currentStepSelector, isConfiguredSelector as isScimConfiguredSelector, isLoadingSelector } from './selectors';
import { setCurrentStep } from './slice';
import { fetchScimSettings } from './thunks';
import { Step } from '../shared/step';
import { Description } from '../styles';
const SetupGuideLink = ({
  children
}) => <Link href="https://help.calendly.com/hc/en-us/articles/4403420585623" target="_blank" rel="noreferrer noopener">{children}</Link>;
const styledDeleteScimButtonCss = "s1ew2nk8";
const StyledDeleteScimButton = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledDeleteScimButtonCss, props.className)} />;
});
export const SetupComponent = () => {
  const dispatch = useDispatch();
  const selectedStep = useSelector(currentStepSelector);
  const isLoading = useSelector(isLoadingSelector);
  const isScimConfigured = useSelector(isScimConfiguredSelector);
  useEffect(() => {
    dispatch(fetchScimSettings());
  }, [dispatch]);
  return <>
      <FlexLayout direction="column" gap={16}>
        <TitleText level={2} size="medium">
          {I18n.t('publisher.organization_settings.user_provisioning.header')}
        </TitleText>
        <Description>
          {HtmlParser(I18n.t('publisher.organization_settings.user_provisioning.description'), {
          SetupGuideLink
        })}
        </Description>
      </FlexLayout>
      <StyledDeleteScimButton>
        <DeleteScimConfigurationButton />
      </StyledDeleteScimButton>
      {isLoading ? <Loader data-testid="step-loader" /> : <>
            <Step selected={selectedStep === USER_PROVISIONING_STEPS.SCIM_PROVISIONING} complete={isScimConfigured} onSelect={() => dispatch(setCurrentStep(USER_PROVISIONING_STEPS.SCIM_PROVISIONING))} title={I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.title')}>
              <ScimConfiguration />
            </Step>
            <Step selected={selectedStep === USER_PROVISIONING_STEPS.GROUP_MAPPING} disabled={!isScimConfigured} disabledMessage={I18n.t('publisher.organization_settings.user_provisioning.groups.disabled_message')} onSelect={() => dispatch(setCurrentStep(USER_PROVISIONING_STEPS.GROUP_MAPPING))} title={I18n.t('publisher.organization_settings.user_provisioning.groups.title')}>
              <Groups />
            </Step>
          </>}
    </>;
};

require("./setup_component.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./setup_component.js");